import React from 'react';
import PropTypes from 'prop-types';
import ProductCard from '@prisjakt/ui-product-card';
import SparkLine from '@prisjakt/ui-sparkline';
import ProductImage from '@prisjakt/ui-product-image';

const CampaignItem = props => (
  <ProductCard
    {...props}
    image={<ProductImage name={props.product.name} src={props.product.image} />}
    name={props.product.name}
    subtitle={props.product.category.name}
    link={props.product.link}
    onClick={props.onClick}
    diffPercentage={props.diffPercentage}
    linkAttributes={props.linkAttributes}
    rating={props.product.rating}
    ratingCount={props.product.ratingCount}
    price={props.product.price}
    store={props.store}
    isCampaignItem
    hasDivider={props.hasDivider}
    className={props.className}
    externalLink={props.externalLink}
  >
    {props.freeShipping && <div>{props.freeShipping}</div>}
    {props.soldByXNrOfStores && <div>{props.soldByXNrOfStores}</div>}
    {props.previousPriceText && <div>{props.previousPriceText}</div>}
    {props.statistics ? (
      <div>
        <span style={{ marginRight: '0.5rem' }}>{props.statistics.label}</span>
        <SparkLine
          width={25}
          height={10}
          values={props.statistics.values}
          solidBackground
        />
      </div>
    ) : (
      ''
    )}
  </ProductCard>
);

CampaignItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    image: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    rating: PropTypes.number,
    ratingCount: PropTypes.number,
    category: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  store: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    hasLogo: PropTypes.bool.isRequired,
  }),
  statistics: PropTypes.shape({
    label: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.number),
    link: PropTypes.string,
  }),
  diffPercentage: PropTypes.number.isRequired,
  freeShipping: PropTypes.string,
  previousPriceText: PropTypes.node,
  soldByXNrOfStores: PropTypes.string,
  onClick: PropTypes.func,
  hasDivider: PropTypes.bool,
  linkAttributes: PropTypes.shape({
    target: PropTypes.string,
    rel: PropTypes.string,
  }),
  className: PropTypes.string,
  externalLink: PropTypes.bool,
};

CampaignItem.defaultProps = {
  product: {
    image: undefined,
    rating: undefined,
    count: undefined,
    category: {
      name: undefined,
    },
  },
  store: undefined,
  statistics: undefined,
  freeShipping: undefined,
  previousPriceText: undefined,
  soldByXNrOfStores: undefined,
  onClick: () => {},
  hasDivider: false,
  linkAttributes: undefined,
  className: '',
  externalLink: false,
};

export default CampaignItem;
